import { currencyOptions } from './currency-options';
import { packageStatusOptions } from './package-status-options';
import { controllerOptions } from './controller-options';
import { subscriptionOptions } from './subscription-options';

export const schema = {
  name: { type: 'string', title: 'Name' },
  description: { type: 'string', title: 'Description' },
  status: { type: 'select', title: 'Status', options: packageStatusOptions },
  type: { type: 'select', title: 'Type', options: subscriptionOptions },
  currency_code: {
    type: 'select',
    title: 'Currency code',
    options: currencyOptions,
  },
  secureAmount: { type: 'number', title: 'Secure amount' },
  promotional_credit: { type: 'number', title: 'Promotional credit' },
  block_without_dunning: { type: 'checkbox', title: 'Block without dunning' },
  enableSocialLoginFlow: { type: 'checkbox', title: 'Enable Social Login' },
  excludePromotionalCredit: {
    type: 'checkbox',
    title: 'Exclude promotional credit',
    showDivider: true,
  },
  annually_headline: { type: 'string', title: 'Annually headline' },
  checkout_cta_text: { type: 'string', title: 'Checkout cta text' },
  get_started_text: { type: 'string', title: 'Get started text' },
  summary_text: { type: 'string', title: 'Summary text' },
  monthly_headline: { type: 'string', title: 'Monthly headline' },
  template_partner_id: { type: 'number', title: 'Template partner id' },
  what_does_it_include: {
    type: 'string',
    title: 'What does it include',
    showDivider: true,
  },
  partner_config: { type: 'jsonString', title: 'Partner config' },
  partner_register_config: {
    type: 'jsonString',
    title: 'Partner register config',
    showDivider: true,
  },
  leading_plan: {
    type: 'jsonString',
    title: 'Leading plan',
    showDivider: true,
  },
  monthly_addons: {
    type: 'jsonString',
    title: 'Monthly addons',
    showDivider: true,
  },
  yearly_addons: {
    type: 'jsonString',
    title: 'Yearly addons',
    showDivider: true,
  },
  getting_started_media_url: {
    type: 'string',
    title: 'Getting started media url',
  },
  create_account_media_url: {
    type: 'string',
    title: 'Create account media url',
    showDivider: true,
  },
  marketing_info: { type: 'jsonString', title: 'Marketing info' },
  company_size_list: { type: 'jsonString', title: 'Company size list' },
  department_list: { type: 'jsonString', title: 'Department list' },
  custom_data: { type: 'jsonString', title: 'Custom Data' },
};
